import { render, staticRenderFns } from "./AllowWebCall.vue?vue&type=template&id=93cd378c&scoped=true&"
import script from "./AllowWebCall.vue?vue&type=script&lang=js&"
export * from "./AllowWebCall.vue?vue&type=script&lang=js&"
import style0 from "./AllowWebCall.vue?vue&type=style&index=0&id=93cd378c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93cd378c",
  null
  
)

export default component.exports